import * as JsonFormatter from 'spark-util/JsonObjectFormatter';
import get from 'lodash/get';
//import actionCreators from 'spark-state/actionCreators';

export const SET_BULK_DOWNLOAD_STATUS = 'BULK_DOWNLOAD.SET_BULK_DOWNLOAD_STATUS';
export const SET_BULK_DOWNLOAD_RESULTS_GRID = 'BULK_DOWNLOAD.SET_BULK_DOWNLOAD_RESULTS_GRID';
export const SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS = 'BULK_DOWNLOAD.SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS';
export const SET_BULK_DOWNLOAD_FILTERS = 'BULK_DOWNLOAD.SET_BULK_DOWNLOAD_FILTERS';

export const setBulkDownloadStatus = (bulkDownloadStatus) => ({
	type: SET_BULK_DOWNLOAD_STATUS,
	bulkDownloadStatus
});
export const setBulkDownloadResultsGrid = (status) => (		{type: SET_BULK_DOWNLOAD_RESULTS_GRID,
	status})

export const setBulkDownloadFilters = (filters) => ({
	type: SET_BULK_DOWNLOAD_FILTERS,
	filters
})

export const setSafetyNotificationsForBulkDownload = (response) =>({ 
	type: SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS, 
	response })

export const getNotificationById = (state, id) => get(state, `bulkdownload.bulkDownloadNotifications[${id}]`);

export const isBulkDownloadComplete = (state) => state.bulkdownload.isBulkDownloadComplete;
export const getBulkDownloadFilters = (state) => state.bulkdownload.bulkDownloadFilters || {};
export const getBulkDownloadResultsGrid = (state) => state.bulkdownload.displayBulkDownloadGrid;
export const getBulkDownloadNotifications = (state) => state.bulkdownload.bulkDownloadNotifications;
export const getSafetyLetterIds = (state, gridName) => get(state, `grid[${gridName}].order`);
export const getSafetyLetterTotalElements = (state, gridName) => get(state, `grid[${gridName}].totalElements`);

const initialState = {
	
		isBulkDownloadComplete: false,
		displayBulkDownloadGrid: false,
		bulkDownloadFilters: {},
		bulkDownloadNotifications : [],
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
        case SET_BULK_DOWNLOAD_STATUS: {
			return {
				...state,
				isBulkDownloadComplete: action.bulkDownloadStatus
			};
		}
        case SET_BULK_DOWNLOAD_RESULTS_GRID: {
			return {
				...state,
				displayBulkDownloadGrid: action.status
			};
		}
		case SET_BULK_DOWNLOAD_FILTERS: {
			return {
				...state,
				bulkDownloadFilters: action.filters || {}
			};
		}
		case SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS: {
			return {
				...state,
			bulkDownloadNotifications: JsonFormatter.arrayToObject(
				'safetyId',
				get(action.response, 'data.content', [])			)
				
			};
		}
		default: {
			return state;
		}
    }
}